<template>
  <div class="put">
    <template v-if="!moreOpenItem">
      <div class="put-left"  v-if="cardList.length>0">
          <el-carousel
                  v-if="cardList.length>0"
                  :interval="5000"
                 arrow="never"
                 :autoplay="false"
                 indicator-position="none">
            <el-carousel-item v-for="(item,index) in cardList" :key="index">
              <div class="put-content">
                <div class="put-icon">
                  <div class="card-icon" :class="formattOpenClass(item.bidOpeningStatus)">{{formattOpenStatus(item.bidOpeningStatus)}}</div>
                  <div class="card-icon" :class="formattEvalStatusClass(item.evalStatus)">{{formattEvalStatus(item.evalStatus)}}</div>
                </div>
                <div class="put-text">
                  <span class="bid-title">{{item.bidName}}</span>
                </div>
                <div class="open-room">
                  <i class="el-icon-s-home"></i>
                  <span class="rooms-sub">开标室：</span>
                  <span calss="rooms-value">
                    <span v-for="it in item.bidOpenRooms">{{it.filedName}}</span>
                  </span>
                </div>
                <div class="bid-room">
                  <i class="el-icon-s-home"></i>
                  <span class="rooms-sub">评标室：</span>
                  <span calss="rooms-value">
                    <span v-for="it in item.evalRooms">{{it.filedName}}</span>
                  </span>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
      </div>
      <div class="put-btn">
        <!--     color: rgb(101, 165, 249 -->
        <div class="allViewBtn"  v-if="!moreOpenItem" @click="$emit('getDown',true)"><span>查看全部开标监管</span><i class="el-icon-arrow-down" style="line-height:28px;"/></div>
      </div>
    </template>
    <template v-else>
      <div class="put-close">
        <div class="allViewBtn" v-if="moreOpenItem" @click="$emit('getUp',false)"><span>查看全部开标监管</span><i class="el-icon-arrow-up" style="line-height:28px;"/></div>
      </div>
    </template>
    <div class="put-check">
      <span @click="$emit('getCardList')" :style="{'color':showCardFlag?'#1890FF':'#000000'}" title="卡片"><i class="el-icon-menu" ></i></span>
      <span @click="$emit('getList')" :style="{'color':!showCardFlag?'#1890FF':'#000000'}" title="列表"><i class="el-icon-s-operation"></i></span>
    </div>
  </div>
</template>
<script>
export default {
  props:["moreOpenItem",'cardList','showCardFlag'],
  data() {
    return {
      dataListLoading: false,
    };
  },
  created() {

  },
  activated() {

  },
  mounted() {
  },
  methods: {
    formattEvalStatus(evalStatus){
      switch(evalStatus){
        case 1 : return '等待评标'; break;
        case 2 : return '评标准备中'; break;
        case 3 : return '评标中'; break;
        case 4 : return '评标流标'; break;
        case 5 : return '评标结束'; break;
      }
    },
    formattEvalStatusClass(evalStatus){
      switch(evalStatus){
        case 1 : return 'eval-waiting'; break;
        case 2 : return 'eval-waiting'; break;
        case 3 : return 'eval-biding'; break;
        case 4 : return 'eval-end'; break;
        case 5 : return 'eval-end'; break;
      }
    },
    formattOpenStatus(openStatus){
      switch(openStatus){
        case 1 : return '等待开标'; break;
        case 2 : return '开标中'; break;
        case 3 : return '取消开标'; break;
        case 4 : return '开标流标'; break;
        case 5 : return '开标结束'; break;
      }
    },
    formattOpenClass(openStatus){
      switch(openStatus){
        case 1 : return 'bid-waiting'; break;
        case 2 : return 'bid-biding'; break;
        case 3 : return 'bid-end'; break;
        case 4 : return 'bid-end'; break;
        case 5 : return 'bid-end'; break;
      }
    },
  },

}
</script>
<style lang="scss" scoped>
.put{
  position: relative;
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  /*box-shadow: 0px 0px 8px 0px rgba(72, 92, 109, 0.2);*/
  border-radius: 2px;
  line-height: 40px;
  margin-bottom: 24px;
  text-align: right;
  .put-left{
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    width: 82%;
    float: left;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(72, 92, 109, 0.2);
    border-radius: 2px;
    padding: 0 16px;
    /deep/ .put-content{
      height: 40px;
      background: #FFFFFF;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .put-icon{
        width:152px;
        .card-icon{
          width: 68px;
          height: 18px;
          border-radius: 2px;
          text-align: left;
          line-height: 18px;
          padding-right: 4px;
          color: #FFFFFF;
          display: inline-block;
          font-size: 12px;
          margin-left: 4px;
          padding-left: 4px;
        }
        .bid-end{
          background: linear-gradient(-45deg, transparent 10px, #A5AEB6 0);
        }
        .bid-biding{
          background: linear-gradient(-45deg, transparent 10px, #EF6E71 0);
        }
        .bid-waiting{
          background: linear-gradient(-45deg, transparent 10px, #5FABFF 0);
        }
        .eval-end{
          background: linear-gradient(-45deg, transparent 10px, #A5AEB6 0);
        }
        .eval-biding{
          background: linear-gradient(-45deg, transparent 10px, #EF6E71 0);
        }
        .eval-waiting{
          background: linear-gradient(-45deg, transparent 10px, #5FABFF 0);
        }
      }
      .put-text{
        width: calc(70% - 152px);
        .bid-title{
          display: inline-block;
          color: rgba(0, 0, 0, 0.85);
        }
      }

      .open-room{
        width: 15%;
        display: inline-block;
        color: #7390AB;
        .rooms-sub{
          color: #000000;
        }
      }
      .bid-room{
        width: 15%;
        display: inline-block;
        color: #7390AB;
        .rooms-sub{
          color: #000000;
        }
      }
    }

  }
}
.put-btn{
  margin-right: 60px;
  padding:0 10px;
  width: 150px;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  background: rgba(24, 144, 255, 0.1);
  border-radius: 2px;
}
    .allViewBtn{
        color:#3E8EF7;
        display: flex;
        justify-content: center;
    }
  .allViewBtn:hover{
   color: rgb(101, 165, 249);
  }
.put-check{
  position: absolute;
  right: 0px;
  top: 5px;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  font-size: 24px;
  cursor: pointer;
  // text-align: right;
  color: rgba(0, 0, 0, 0.65)
}
.put-check span{
  cursor: pointer;
}
.put-close{
  width:  150px;
  margin: 0 15px;
  padding:0 10px;
  position: absolute;
  right: 0px;
  top: 5px;
  display: inline-block;
  height: 28px;
  line-height: 28px;
  background: rgba(24, 144, 255, 0.1);
  border-radius: 2px;
  text-align: right;
  margin-right: 50px;
}
</style>